import request from '@/utils/request'
const apiPath = '/sys/sysPayLog'
const sysPayLogApi = {
  /**
   * 分页查询【支付日志】
   */
  fetchList(query) {
    return request.get(`${apiPath}/teev2`, { params: query })
  }
}
export default sysPayLogApi






